<template>
	<div class="login-container">
		<div class="login-content">
			<h2 style="text-align: center;">登录</h2>
			<el-form ref="loginForm" :model="loginForm" :rules="rules" label-width="80px" label-position="left">
				<el-form-item label="用户名" prop="userName">
					<el-input v-model="loginForm.userName" />
				</el-form-item>
				<el-form-item label="密码" prop="password">
					<el-input v-model="loginForm.password" />
				</el-form-item>
				<el-form-item>
					<el-button style="width: 100%;" @click="submit" type="primary">登录</el-button>
				</el-form-item>
			</el-form>
		</div>
	</div>
</template>

<script>
	import {login} from '../../api/login.js'
	export default {
		data() {
			return {
				loginForm: {
					userName: "",
					password: ""
				},
				rules:{
					userName:[
						{required: true, message: '请输入账号', trigger: 'blur'}
					],
					password:[
						{required: true, message: '请输入密码', trigger: 'blur'}
					]
				}
			}
		},
		methods:{
			submit(){
				this.$refs.loginForm.validate(async valid =>{
					if(valid){
						console.log(this.loginForm)
						await login(this.loginForm)
						// console.log(this.$cookies.get('token'))
						this.$store.commit('SET_USERNAME',this.loginForm.userName)
						console.log(this.$store.state.userName)
						this.$router.push({
							path:'/'
						})
					}else{
						return false
					}
				})
			}
		}
	}
</script>

<style lang="scss">
	.login-container {
		width: 100vw;
		height: 100vh;
		background-image: url(../../assets/login/login.jpg);
		background-size: 100% 100%;
		display: flex;
		justify-content: center;
		align-items: center;

		.login-content {
			width: 350px;
			height: 280px;
			background-color: rgba(255, 255, 255, .8);
			border-radius: 20px;
			padding: 0 30px;
		}
	}
</style>
